import { ThemeOptions } from '@mui/material/styles';
import merge from 'lodash/fp/merge';

import themeOptions from './common';

export default merge<Partial<ThemeOptions>>({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      mobile: 450,
      tablet: 850,
      tabletL: 1024,
      dsm: 1280,
      dmd: 1440,
      dlg: 1536,
      dxl: 1920,
    },
  },
  palette: {
    mode: 'dark',
    background: {
      default: '#202020',
    },
    primary: {
      light: '#87a6ff',
      dark: '#004dc1',
      main: '#367cff',
    },
  },
  typography: {
    subtitle1: {
      color: '#9ac9f5',
    },
    h5: {
      color: '#9ac9f5',
    },
    body1: {
      color: '#f8f8f8',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#262626',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: '#9ac9f5',
        },
      },
    },
  },
})(themeOptions);
